import React, { useState } from 'react';
import AsyncTypeaheadInput from '../../shared/components/async_typeahead_input';
import { api } from '../../shared/utils/api';
import { ADD_CONVERSATION_TO_LIST_ASYNC } from '../reducers/messenger_reducers';
import PropTypes from 'prop-types';

const ConversationCreator = ({
  id,
  close,
  open,
  dispatchConversationListAction,
  inputRef
}) => {
  const [message, setMessage] = useState('');
  const [multiSelections, setMultiSelections] = useState([]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && message !== '' && multiSelections.length > 0) {
      e.preventDefault();
      api.post(`/messenger`,
        {
          participant_ids: multiSelections.map(user => user.id),
          body: message
        },
        { baseURL: '/' }
      )
        .then(res => {
          dispatchConversationListAction({ type: ADD_CONVERSATION_TO_LIST_ASYNC, conversation: res.data })
          if (res.status === 200) {
            open(res.data);
          }
        })

      setMessage('');
      close(e, id);
    }
  };

  const handleChange = (e) => setMessage(e.target.value);

  return (
    <>
      <div>
        <AsyncTypeaheadInput
          multiSelections={multiSelections}
          setMultiSelections={setMultiSelections}
          searchURI={'/messenger/search'}
          ref={inputRef}
        />
      </div>
      <div className="module-body convo-window creator">
      </div>
      <div>
        <input
          className="message-input form-control"
          type="text"
          placeholder="Write your message ..."
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          value={message}
        />
      </div>
    </>
  );
};

ConversationCreator.propTypes = {
  id: PropTypes.string.isRequired,
  dispatchConversationListAction: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  open: PropTypes.func.isRequired
};

export default ConversationCreator;
